import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import useApis from '../services/hooks/useApis.js';
import { BearerTokenContext } from '../services/context/BearerTokenContext.js';
import { SubscriptionDetailsContext, UpdateSubscriptionDetailsContext } from '../services/context/SubscriptionDetailsContext.js';
import { UserDetailsContext } from '../services/context/UserDetailsContext.js';

/**
 * @param {object} props - The props for the controller
 * @param {React.ReactNode} props.slot - The content to display within this controller
 * @returns {JSX.Element} The Controller Component
 */
export default function SubscriptionDetailsController({ slot }) {
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const bearerToken = useContext(BearerTokenContext);
  const userDetails = useContext(UserDetailsContext);
  const { getSubscriptionDetails } = useApis();

  // getSubscriptionDetails API integration
  const getSubscriptionPopUp = () => {
    getSubscriptionDetails(bearerToken)
      .then(response => {
        if (response && response?.status === 200) {
          const expiryDate = Date.now();
          // Determine if popup should show (only for new users)
          const isShowPopUp = !response?.data?.isSubscribed && response?.data?.isEligibleToSubscribe;
          const isSuspended = !response?.data?.isSubscribed && !response?.data?.isEligibleToSubscribe;

          setSubscriptionDetails({
            status: response?.status,
            plans: response?.data?.plans || [],
            isSubscribed: response?.data?.isSubscribed,
            subscribedPlan: response?.data?.subscribePlan || {},
            isEligibleToSubscribe: response?.data?.isEligibleToSubscribe,
            expiryDate,
            isShowPopUp,
            isSuspended,
            planExpiryDate: response?.data?.subscribePlan?.expiryDate || null,
            isAutoRenewal: response?.data?.subscribePlan?.isAutoRenewal || null,
            existingPackageId: response?.data?.subscribePlan?.existingPackageId || null,
          });
        } else {
          setSubscriptionDetails({ status: response?.status });
        }
      })
      .catch(() => {
        setSubscriptionDetails(null);
      });
  };

  useEffect(() => {
    if (bearerToken && userDetails.vsp) {
      getSubscriptionPopUp();
    }
  }, [
    bearerToken,
    userDetails,
  ]);

  return (
    <SubscriptionDetailsContext.Provider value={ subscriptionDetails }>
      <UpdateSubscriptionDetailsContext.Provider value={ setSubscriptionDetails }>
        {slot}
      </UpdateSubscriptionDetailsContext.Provider>
    </SubscriptionDetailsContext.Provider>
  );
}

SubscriptionDetailsController.propTypes = { slot: PropTypes.element };
